import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-526b9a2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create tournament", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overline text-center mb-4" }, "MATCH ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_tournament_brackets = _resolveComponent("tournament-brackets")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        loading: _ctx.loading.matchCard,
                        class: "mx-auto",
                        raised: "",
                        height: "280px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, { "three-line": "" }, {
                            default: _withCtx(() => [
                              (_ctx.match)
                                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                    default: _withCtx(() => [
                                      (_ctx.loading.tournament)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_skeleton_loader, { type: "card" })
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_col, {
                                            key: 1,
                                            cols: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_avatar, {
                                                tile: "",
                                                color: "grey",
                                                size: "80",
                                                rounded: "0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_img, {
                                                    src: _ctx.match.posLeft.player.avatar
                                                  }, null, 8, ["src"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_text_field, {
                                                modelValue: _ctx.match.posLeft.player.avatar,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.match.posLeft.player.avatar) = $event)),
                                                label: "avatar",
                                                variant: "underlined"
                                              }, null, 8, ["modelValue"]),
                                              _createVNode(_component_v_text_field, {
                                                modelValue: _ctx.match.posLeft.player.name,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.match.posLeft.player.name) = $event)),
                                                label: "Name",
                                                variant: "underlined"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })),
                                      _createVNode(_component_v_col, { cols: "4" }, {
                                        default: _withCtx(() => [
                                          _hoisted_2,
                                          _createVNode(_component_v_list_item_title, { class: "headline text-center" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" VS ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.loading.tournament)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 2,
                                            cols: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_skeleton_loader, { type: "card" })
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_col, {
                                            key: 3,
                                            cols: "4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_avatar, {
                                                tile: "",
                                                size: "80",
                                                color: "grey",
                                                rounded: "0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_img, {
                                                    src: _ctx.match.posRight.player.avatar
                                                  }, null, 8, ["src"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_text_field, {
                                                modelValue: _ctx.match.posRight.player.avatar,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.match.posRight.player.avatar) = $event)),
                                                label: "avatar",
                                                variant: "underlined"
                                              }, null, 8, ["modelValue"]),
                                              _createVNode(_component_v_text_field, {
                                                modelValue: _ctx.match.posRight.player.name,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.match.posRight.player.name) = $event)),
                                                label: "Name",
                                                variant: "underlined"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_actions, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                onClick: _ctx.saveCardLoading,
                                disabled: !(_ctx.playerLeftSavable || _ctx.playerRightSavable) || _ctx.loading.matchCard,
                                variant: "tonal",
                                color: "success"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("save")
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"]),
                              _createVNode(_component_v_spacer)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      (_ctx.loading.tournamentCard || _ctx.loading.tournament)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 0,
                            class: "mx-auto",
                            raised: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_skeleton_loader, {
                                type: "heading,list-item,list-item,actions",
                                height: "280px"
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_v_card, {
                            key: 1,
                            height: "280px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Tournament")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("settings")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { class: "mx-1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "8" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.tournament.name,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tournament.name) = $event)),
                                        label: "Name",
                                        variant: "underlined",
                                        required: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        modelValue: _ctx.tournament.size,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tournament.size) = $event)),
                                        label: "Size",
                                        items: [2, 4, 8, 16],
                                        variant: "underlined",
                                        required: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { class: "mx-1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "10" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.tournament.matchTime,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tournament.matchTime) = $event)),
                                        label: "Match time in seconds",
                                        variant: "underlined",
                                        type: "number",
                                        required: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    onClick: _ctx.updateTournament,
                                    variant: "tonal",
                                    color: "success",
                                    disabled: !_ctx.settingsSavable
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Save")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick", "disabled"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _ctx.start,
                                    variant: "flat",
                                    color: "success",
                                    disabled: !_ctx.startable
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" START "),
                                      _createVNode(_component_v_tooltip, {
                                        activator: "parent",
                                        location: "top"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("add all players before start " + _toDisplayString(_ctx.savedPositions.size) + "/8", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              (_ctx.loading.tournament)
                                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                                    key: 0,
                                    type: "table-row,table-row,table-row,table-row,table-row,table-row,table-row"
                                  }))
                                : (_openBlock(), _createBlock(_component_tournament_brackets, {
                                    key: 1,
                                    edit: true
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}